import {
  SingleProviderConfig,
  ShopType,
  CheckoutType,
  CrossSellType,
} from 'types';
import { allLeadMode, getDefaultCrossSellAction } from 'config';
import {
  ATT,
  Brightspeed,
  CenturyLink,
  QuantumFiber,
  Frontier,
  Windstream,
  CincinnatiBell,
  Verizon,
  //Earthlink,
} from 'config/providers';
import { ATTTheme } from 'config/themes';

// Origin - https://updater.atlassian.net/browse/TVI-1215
export const CordlessATTPartner: SingleProviderConfig = {
  name: 'CordlessATTPartner',
  micrositeCode: 'cordlessattpartner',
  mainProvider: ATT,
  shopType: ShopType.SINGLE_PROVIDER,
  // shopType: ShopType.SYNTHETIC,
  domain: 'attspecial.com',
  homepage: 'https://attspecial.com',
  title: 'AT&T Authorized Dealer',
  fallbackPhoneNumber: '844-710-5188 ',
  fallbackLeadModePhoneNumber: '844-647-7953',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: ATTTheme,
  needsDcSession: false,
  source: 'ATT',
  noOffersRetry: 2,
  getCrossSellAction: getDefaultCrossSellAction,
  getCheckoutType: allLeadMode,
  crossSellProviders: [
    Verizon,
    Brightspeed,
    CenturyLink,
    QuantumFiber,
    Frontier,
    Windstream,
    CincinnatiBell,
  ],
  updaterCrossSellActive: true,
  updaterCrossSellProviders: [
    ATT,
    CenturyLink,
    QuantumFiber,
    CincinnatiBell,
    Frontier,
    Windstream,
  ],
};
